import { companyRequest } from '@/company/api';

export type ArchiveKind = 'file' | 'result';
export type ArchivedItem = {
  id: string;
  title: string;
  archivedAt: string;
  restoreUntil: string;
};
export type ArchivePage = { items: ArchivedItem[]; nextOffset: number | null };
const path = (kind: ArchiveKind, id: string) =>
  `/api/v1/company/${kind}s/${encodeURIComponent(id)}`;

export const itemArchiveApi = {
  delete: (kind: ArchiveKind, id: string, session: typeof fetch) =>
    companyRequest<Omit<ArchivedItem, 'title'>>(
      path(kind, id),
      'DELETE',
      { confirmed: true },
      session,
    ),
  list: (kind: ArchiveKind, offset: number, session: typeof fetch) =>
    companyRequest<ArchivePage>(
      `${path(kind, 'archive')}?offset=${offset}`,
      'GET',
      undefined,
      session,
    ),
  restore: (kind: ArchiveKind, id: string, session: typeof fetch) =>
    companyRequest<{ id: string }>(
      `${path(kind, id)}/restore`,
      'POST',
      { confirmed: true },
      session,
    ),
};
